import { render } from "./Footer.vue?vue&type=template&id=ea6609da&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=ea6609da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea6609da"]])

export default __exports__